<template>
  <div id="page-user-list">
    <vx-card
      ref="filterCard"
      title="Filters"
      class="user-list-filters mb-8"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select
            :options="roleOptions"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="roleFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select
            :options="employeeStatus"
            label="status"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="statusFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select
            :options="isVerifiedOptions"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="isVerifiedFilter"
            class="mb-4 sm:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select
            :options="departments"
            label="departmentName"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="departmentFilter"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>

                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                        <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                        <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                        <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                        <span>30</span>
                    </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
             </div> -->

        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
      <vs-button
        type="gradient"
        color="primary"
        @click="promptAddNewEmployee()"
        icon-pack="feather"
        icon="icon-plus"
        >Add</vs-button
      >
    </div>

    <!-- ADD NEW EMPLOYEE/USERS -->
    <vs-prompt
      class="email-compose employee-registration-prompt"
      title="Register Employee"
      :buttons-hidden="true"
      :active.sync="activePromptNewEmployee"
    >
      <form-wizard
        ref="employeeWizard"
        color="rgba(var(--vs-primary), 1)"
        error-color="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        step-size="sm"
        next-button-text="Next"
        back-button-text="Back"
        finish-button-text="Submit"
        @on-change="onEmployeeStepChange"
        @on-complete="onAddEmployee"
      >
        <template slot="next" slot-scope="props">
          <wizard-button
            :style="props.fillButtonStyle"
            :class="{ 'wizard-button-pending': !currentWizardStepValid }"
          >
            Next
          </wizard-button>
        </template>
        <template slot="finish" slot-scope="props">
          <wizard-button
            :style="props.fillButtonStyle"
            :class="{ 'wizard-button-pending': !salaryInformationStepValid }"
          >
            Submit
          </wizard-button>
        </template>
        <tab-content title="Employee" :before-change="validateEmployeeStep">
          <vx-card title="Fill-out the following information">
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Employee Code</span
            ><span style="color: red">*</span>
            <vs-input
              class="w-full"
              v-validate="'required'"
              name="employee code"
              v-model="registerNewEmployee.employeeCode"
              placeholder="Employee Code"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('employee code')"
              >{{ errors.first("employee code") }}</span
            >
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
            <span class="text-sm">First Name</span
            ><span style="color: red">*</span>
            <vs-input
              class="w-full"
              v-validate="'required'"
              name="first name"
              v-model="registerNewEmployee.firstName"
              placeholder="First Name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('first name')"
              >{{ errors.first("first name") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
            <span class="text-sm">Last Name</span
            ><span style="color: red">*</span>
            <vs-input
              class="w-full"
              v-validate="'required'"
              name="last name"
              v-model="registerNewEmployee.lastName"
              placeholder="Last Name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('last name')"
              >{{ errors.first("last name") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
            <span class="text-sm">Middle Name</span
            ><span style="color: red">*</span>
            <vs-input
              class="w-full"
              v-validate="'required'"
              name="middle name"
              v-model="registerNewEmployee.middleName"
              placeholder="Middle Name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('middle name')"
              >{{ errors.first("middle name") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
            <span class="text-sm">Email</span><span style="color: red">*</span>
            <vs-input
              class="w-full"
              v-validate="'email'"
              name="email"
              v-model="registerNewEmployee.email"
              placeholder="Email"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full mb-2">
            <span class="text-sm">Company Name</span
            ><span style="color: red">*</span>
            <v-select
              v-validate="'required'"
              name="Company Name"
              class="w-full"
              v-model="tenantName"
              label="name"
              :options="getAllTenant"
              placeholder="Please Select"
            />
            <span class="text-danger text-sm">{{
              errors.first("step-1.Company Name")
            }}</span>
          </div>
        </div>
          </vx-card>
        </tab-content>

        <tab-content title="Identification" :before-change="validateIdentificationStep">
          <vx-card title="Employee Identification">
        <div class="vx-row">
          <div
            v-for="field in identificationLookups"
            :key="field.model"
            class="vx-col md:w-1/2 w-full mb-4"
          >
            <span class="text-sm">{{ field.label }}</span>
            <span v-if="field.required" style="color: red">*</span>
            <v-select
              v-model="formSelections[field.model]"
              :options="field.options"
              :label="field.optionLabel"
              placeholder="Please Select"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-4">
            <span class="text-sm">Referred By</span>
            <vs-input class="w-full" v-model="employeeIdentification.referredby" />
          </div>
          <div class="vx-col md:w-1/2 w-full mb-4">
            <span class="text-sm">Relative Employed</span>
            <v-select
              v-model="formSelections.relativeEmployed"
              :options="usersData"
              label="fullName"
              placeholder="Please Select"
            />
          </div>
          <div
            v-for="field in identificationTextFields"
            :key="field.model"
            class="vx-col md:w-1/2 w-full mb-4"
          >
            <span class="text-sm">{{ field.label }}</span>
            <vs-input class="w-full" v-model="employeeIdentification[field.model]" />
          </div>
          <div class="vx-col md:w-1/2 w-full mb-4">
            <vs-checkbox v-model="employeeIdentification.appliedBefore">Applied Before</vs-checkbox>
          </div>
          <div class="vx-col md:w-1/2 w-full mb-4">
            <vs-checkbox v-model="employeeIdentification.acceptFieldWork">Accept Field Work</vs-checkbox>
          </div>
        </div>
          </vx-card>
        </tab-content>

        <tab-content title="Salary" :before-change="validateSalaryStep">
          <vx-card title="Employee Salary">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-4">
            <span class="text-sm">Annual Working Days</span><span style="color: red">*</span>
            <vs-input class="w-full" type="number" v-model.number="employeeSalary.annualWorkingDays" />
          </div>
          <div class="vx-col md:w-1/2 w-full mb-4">
            <span class="text-sm">Hours per Day</span><span style="color: red">*</span>
            <vs-input class="w-full" type="number" v-model.number="employeeSalary.workHoursPerDay" />
          </div>
          <div class="vx-col md:w-1/3 w-full mb-4">
            <span class="text-sm">Monthly Rate</span><span style="color: red">*</span>
            <vs-input
              class="w-full"
              type="number"
              v-model.number="employeeSalary.monthlyRate"
              placeholder="Enter Monthly Rate"
            />
          </div>
          <div class="vx-col md:w-1/3 w-full mb-4">
            <span class="text-sm">Daily Rate</span><span style="color: red">*</span>
            <vs-input
              class="w-full"
              type="number"
              v-model.number="employeeSalary.dailyRate"
              readonly
            />
          </div>
          <div class="vx-col md:w-1/3 w-full mb-4">
            <span class="text-sm">Hourly Rate</span><span style="color: red">*</span>
            <vs-input
              class="w-full"
              type="number"
              v-model.number="employeeSalary.hourlyRate"
              readonly
            />
          </div>
          <div class="vx-col md:w-1/2 w-full mb-4">
            <span class="text-sm">From Date</span><span style="color: red">*</span>
            <datepicker
              class="w-full"
              calendar-class="employee-salary-calendar"
              v-model="employeeSalary.fromDate"
              placeholder="Select Date"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full mb-4">
            <span class="text-sm">To Date</span>
            <datepicker
              class="w-full"
              calendar-class="employee-salary-calendar"
              v-model="employeeSalary.toDate"
              placeholder="Select Date"
            />
          </div>
        </div>
          </vx-card>
        </tab-content>

        <tab-content title="Salary Information" :before-change="validateSalaryInformationStep">
          <vx-card title="Salary Information">
        <div class="vx-row">
          <div
            v-for="field in salaryInformationLookups"
            :key="field.model"
            class="vx-col md:w-1/2 w-full mb-4"
          >
            <span class="text-sm">{{ field.label }}</span>
            <span v-if="field.required" style="color: red">*</span>
            <v-select
              v-model="formSelections[field.model]"
              :options="field.options"
              :label="field.optionLabel"
              placeholder="Please Select"
            />
          </div>
          <div
            v-for="field in salaryNumberFields"
            :key="field.model"
            class="vx-col md:w-1/2 w-full mb-4"
          >
            <span class="text-sm">{{ field.label }}</span><span style="color: red">*</span>
            <vs-input
              class="w-full"
              v-validate="'required'"
              :name="field.model"
              v-model="employeeSalaryInformation[field.model]"
            />
            <span class="text-danger text-sm" v-show="errors.has(field.model)">
              {{ errors.first(field.model) }}
            </span>
          </div>
        </div>
          </vx-card>
        </tab-content>
      </form-wizard>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

import Swal from "sweetalert2";
import Datepicker from "vuejs-datepicker";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererDepartment from "./cell-renderer/CellRendererDepartment.vue";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";

const emptyEmployee = () => ({
  employeeCode: "",
  firstName: "",
  lastName: "",
  middleName: "",
  email: "",
  tenantsId: null,
  password: "",
  isActive: true,
  isIncludeInfo: true,
});

const emptyIdentification = () => ({
  referredby: "",
  appliedBefore: false,
  acceptFieldWork: false,
  accusedCrime: "",
  illnesses: "",
  physicalCondition: "",
  skillsHobbies: "",
  enjoyMost: "",
  emergencyNotify: "",
  contactNo: "",
});

const emptySalary = () => ({
  monthlyRate: null,
  dailyRate: null,
  hourlyRate: null,
  workHoursPerDay: 8,
  annualWorkingDays: null,
  fromDate: new Date(),
  toDate: null,
  isUsed: true,
  isForOvertime: true,
});

const emptySalaryInformation = () => {
  const information = {
    sssNumber: "",
    philhealthNumber: "",
    pagibigNumber: "",
    tinNumber: "",
    isSSS: true,
    isPhilhealth: true,
    isPagibig: true,
    isWHTax: true,
  };
  ["SSS", "SSSEmployer", "EC", "Philhealth", "PhilhealthEmployer", "Pagibig", "PagibigEmployer", "WHTax"]
    .forEach((name) => {
      information[`fixed${name}Amount`] = 0;
      information[`percent${name}Amount`] = 0;
    });
  return information;
};

const emptySelections = () => ({
  branch: null,
  position: null,
  department: null,
  division: null,
  section: null,
  employeeCategory: null,
  civilStatus: null,
  nationality: null,
  religion: null,
  relationship: null,
  relativeEmployed: null,
  immediateSupervisor: null,
  paymentMode: null,
  taxReference: null,
  salaryBasedOn: null,
  sssPeriod: null,
  philhealthPeriod: null,
  pagibigPeriod: null,
  whTaxPeriod: null,
});

export default {
  components: {
    AgGridVue,
    vSelect,
    // These renderers are resolved dynamically by AG Grid.
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVerified,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererStatus,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererDepartment,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    Datepicker,
    FormWizard,
    TabContent,
    WizardButton,
  },
  created() {
    this.$vs.loading();

    const payload = {
      pageNumber: 1,
      pageSize: -1,
      sortBy: "CreatedOn",
      sortOrder: "Desc",
    };
    // this.$store.dispatch('tenants/getAllTenants', payload)
    const data = {
      pageNumber: -1,
      pageSize: -1,
    };

    this.$store
      .dispatch("hrms/getAllEmployee", data)
      .then(() => {
        this.$vs.loading.close();
        this.setIdentificationDefaults();
      })
      .catch(() => {});
    this.$store
      .dispatch("lookup/getAllDepartment")
      .then(() => this.setIdentificationDefaults())
      .catch(() => {});
    [
      "getAllBranch",
      "getAllPosition",
      "getAllDivision",
      "getAllSection",
      "getAllEmployeeCategory",
      "getAllCivilStatus",
      "getAllNationality",
      "getAllReligion",
      "getAllRelationshipLookup",
      "getAllPaymentModeLookup",
      "getAllSalaryBasedOnLookup",
      "getAllTaxReferenceLookup",
      "getAllPeriodLookup",
    ].forEach((action) => {
      this.$store
        .dispatch(`lookup/${action}`)
        .then(() => {
          this.setIdentificationDefaults();
          this.setSalaryInformationDefaults();
        })
        .catch(() => {});
    });
    this.$store.dispatch("tenants/getAllTenants", payload).catch(() => {});
  },
  computed: {
    usersData() {
      return this.$store.state.hrms.allEmployee;
    },
    // employeeInformation:{
    //     get() { return this.$store.state.hrms.employeeInformation },
    //     set(value) { this.$store.dispatch('hrms/getAllInformation', value)}
    // },
    // employeeIdentification: {
    //     get() { return this.$store.state.hrms.employeeIdentification },
    //     set(value) { }
    // },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    getAllTenant() {
      return this.$store.state.tenants.tenants;
    },
    tenantName: {
      get() {
        return this.$store.getters["tenants/tenantName"](
          this.registerNewEmployee.tenantsId
        );
      },
      set(obj) {
        this.registerNewEmployee.tenantsId = obj ? obj.tenantsId : null;
      },
    },
    employeeStatus() {
      return this.$store.state.lookup.employeeStatus;
    },
    departments() {
      return this.$store.state.lookup.getAllDepartment;
    },
    activePaymentModes() {
      return this.$store.state.lookup.getAllPaymentModeLookup.filter(
        (paymentMode) => paymentMode.isUsed === true || paymentMode.isUsed === 1
      );
    },
    matchingTaxReferences() {
      const paymentMode = this.formSelections.paymentMode;
      if (!paymentMode) return [];
      const paymentModeCode = String(paymentMode.paymentModeCode || "").trim().toLowerCase();
      const taxReferences = this.$store.state.lookup.getAllTaxReferenceLookup;
      const matchingPaymentMode = taxReferences.filter(
        (taxReference) =>
          String(taxReference.taxReferenceCode || "").trim().toLowerCase() === paymentModeCode
      );
      const yearly = taxReferences.filter(
        (taxReference) =>
          String(taxReference.taxReferenceCode || "").trim().toLowerCase() === "yl" &&
          String(taxReference.taxReferenceCode || "").trim().toLowerCase() !== paymentModeCode
      );
      return matchingPaymentMode.concat(yearly);
    },
    matchingPeriods() {
      const paymentMode = this.formSelections.paymentMode;
      if (!paymentMode) return [];
      return this.$store.state.lookup.getAllPeriodLookup.filter(
        (period) => period.paymentModeId === paymentMode.paymentModeId
      );
    },
    identificationLookups() {
      const lookup = this.$store.state.lookup;
      return [
        { model: "branch", label: "Branch", options: lookup.getAllBranch, optionLabel: "branchName", required: true },
        { model: "position", label: "Position", options: lookup.getAllPosition, optionLabel: "positionName", required: true },
        { model: "department", label: "Department", options: lookup.getAllDepartment, optionLabel: "departmentName", required: true },
        { model: "division", label: "Division", options: lookup.getAllDivision, optionLabel: "divisionName", required: true },
        { model: "section", label: "Section", options: lookup.getAllSection, optionLabel: "sectionName", required: true },
        { model: "employeeCategory", label: "Employee Category", options: lookup.getAllEmployeeCategory, optionLabel: "employeeCategoryName", required: true },
        { model: "civilStatus", label: "Civil Status", options: lookup.getAllCivilStatus, optionLabel: "civilStatusName", required: true },
        { model: "nationality", label: "Nationality", options: lookup.getAllNationality, optionLabel: "nationalityName", required: true },
        { model: "religion", label: "Religion", options: lookup.getAllReligion, optionLabel: "religionName", required: true },
        { model: "relationship", label: "Emergency Relationship", options: lookup.getAllRelationshipLookup, optionLabel: "relationshipName" },
        { model: "immediateSupervisor", label: "Immediate Supervisor", options: this.usersData, optionLabel: "fullName", required: true },
      ];
    },
    salaryInformationLookups() {
      const lookup = this.$store.state.lookup;
      return [
        { model: "paymentMode", label: "Payment Mode", options: this.activePaymentModes, optionLabel: "paymentModeName", required: true },
        { model: "taxReference", label: "Tax Deduction Schedule", options: this.matchingTaxReferences, optionLabel: "taxReferenceName", required: true },
        { model: "salaryBasedOn", label: "Salary Based On", options: lookup.getAllSalaryBasedOnLookup, optionLabel: "salaryBasedOnName", required: true },
        { model: "sssPeriod", label: "SSS Deduction Schedule", options: this.matchingPeriods, optionLabel: "periodName" },
        { model: "philhealthPeriod", label: "PhilHealth Deduction Schedule", options: this.matchingPeriods, optionLabel: "periodName" },
        { model: "pagibigPeriod", label: "Pag-IBIG Deduction Schedule", options: this.matchingPeriods, optionLabel: "periodName" },
        { model: "whTaxPeriod", label: "Withholding Tax Schedule", options: this.matchingPeriods, optionLabel: "periodName" },
      ];
    },
    identificationTextFields() {
      return [
        { model: "accusedCrime", label: "Accused of Any Crime" },
        { model: "illnesses", label: "Illness" },
        { model: "physicalCondition", label: "Physical Condition" },
        { model: "skillsHobbies", label: "Skills / Hobbies" },
        { model: "enjoyMost", label: "Enjoy Most" },
        { model: "emergencyNotify", label: "Emergency Contact Person" },
        { model: "contactNo", label: "Emergency Contact Number" },
      ];
    },
    salaryNumberFields() {
      return [
        { model: "sssNumber", label: "SSS Number" },
        { model: "philhealthNumber", label: "PhilHealth Number" },
        { model: "pagibigNumber", label: "Pag-IBIG Number" },
        { model: "tinNumber", label: "TIN Number" },
      ];
    },
    employeeStepValid() {
      const employee = this.registerNewEmployee;
      return Boolean(
        employee.employeeCode &&
        employee.firstName &&
        employee.lastName &&
        employee.middleName &&
        employee.email &&
        /^\S+@\S+\.\S+$/.test(employee.email) &&
        employee.tenantsId
      );
    },
    identificationStepValid() {
      const selections = this.formSelections;
      return Boolean(
        selections.branch &&
        selections.position &&
        selections.department &&
        selections.division &&
        selections.section &&
        selections.employeeCategory &&
        selections.civilStatus &&
        selections.nationality &&
        selections.religion &&
        selections.immediateSupervisor
      );
    },
    salaryStepValid() {
      const salary = this.employeeSalary;
      return Boolean(
        salary.annualWorkingDays &&
        salary.workHoursPerDay &&
        salary.monthlyRate !== null &&
        salary.monthlyRate !== "" &&
        salary.dailyRate !== null &&
        salary.hourlyRate !== null &&
        salary.fromDate
      );
    },
    salaryInformationStepValid() {
      const selections = this.formSelections;
      const numbersComplete = this.salaryNumberFields.every((field) => {
        const value = this.employeeSalaryInformation[field.model];
        return value !== null && value !== undefined && String(value).trim() !== "";
      });
      return Boolean(
        selections.paymentMode &&
        selections.taxReference &&
        selections.salaryBasedOn &&
        selections.sssPeriod &&
        selections.philhealthPeriod &&
        selections.pagibigPeriod &&
        selections.whTaxPeriod &&
        numbersComplete
      );
    },
    currentWizardStepValid() {
      return [
        this.employeeStepValid,
        this.identificationStepValid,
        this.salaryStepValid,
        this.salaryInformationStepValid,
      ][this.employeeFormTab];
    },
    validForm() {
      return (
        this.employeeStepValid &&
        this.identificationStepValid &&
        this.salaryStepValid &&
        this.salaryInformationStepValid
      );
    },
  },
  watch: {
    "employeeSalary.monthlyRate"() {
      this.calculateSalaryRates();
    },
    "employeeSalary.annualWorkingDays"() {
      this.calculateSalaryRates();
    },
    "employeeSalary.workHoursPerDay"() {
      this.calculateSalaryRates();
    },
    "formSelections.paymentMode"(paymentMode, previousPaymentMode) {
      const paymentModeId = paymentMode && paymentMode.paymentModeId;
      const previousPaymentModeId = previousPaymentMode && previousPaymentMode.paymentModeId;
      if (paymentModeId !== previousPaymentModeId) {
        this.formSelections.taxReference = null;
        this.formSelections.sssPeriod = null;
        this.formSelections.philhealthPeriod = null;
        this.formSelections.pagibigPeriod = null;
        this.formSelections.whTaxPeriod = null;
      }
      this.setSalaryInformationDefaults();
    },
    // roleFilter (obj) {
    // this.setColumnFilter('role', obj.value)
    // },
    // statusFilter (obj) {
    // this.setColumnFilter('status', obj.value)
    // },
    // isVerifiedFilter (obj) {
    // const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
    // this.setColumnFilter('is_verified', val)
    // },
    // departmentFilter (obj) {
    // this.setColumnFilter('department', obj.value)
    // }
  },
  data() {
    return {
      activePromptNewEmployee: false,
      employeeFormTab: 0,
      registerNewEmployee: emptyEmployee(),
      employeeIdentification: emptyIdentification(),
      employeeSalary: emptySalary(),
      employeeSalaryInformation: emptySalaryInformation(),
      formSelections: emptySelections(),

      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { status: "All", value: "all" },
      // statusOptions: [
      //     { label: 'All', value: 'all' },
      //     { label: 'Active', value: 'active' },
      //     { label: 'Deactivated', value: 'deactivated' },
      //     { label: 'Blocked', value: 'blocked' }
      // ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { departmentName: "All", value: "all" },
      // departmentOptions: [
      //     { label: 'All', value: 'all' },
      //     { label: 'Sales', value: 'sales' },
      //     { label: 'Development', value: 'development' },
      //     { label: 'Management', value: 'management' }
      // ],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },

      columnDefs: [
        {
          headerName: "ID",
          field: "id",
          width: 125,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Username",
          field: "userName",
          valueGetter: (params) =>
            params.data.userName ||
            params.data.username ||
            params.data.UserName ||
            "",
          filter: true,
          width: 210,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Email",
          field: "email",
          filter: true,
          width: 225,
        },
        {
          headerName: "Employee Number",
          field: "employeeCode",
          filter: true,
          width: 200,
        },
        {
          headerName: "First Name",
          field: "firstName",
          filter: true,
          width: 200,
        },
        {
          headerName: "Last Name",
          field: "lastName",
          filter: true,
          width: 200,
        },
        {
          headerName: "Country",
          field: "employeeInformation.country",
          filter: true,
          width: 150,
        },
        {
          headerName: "Role",
          field: "roles",
          filter: true,
          width: 150,
        },
        {
          headerName: "Status",
          field: "employeeInformation.employeeStatus",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "Verified",
          field: "emailConfirmed",
          filter: true,
          width: 125,
          cellRendererFramework: "CellRendererVerified",
          cellClass: "text-center",
        },
        {
          headerName: "Department",
          field: "employeeIdentification.departmentId",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererDepartment",
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 150,
          // cellRendererFramework: 'CellRendererActions'
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererDepartment,
      },
    };
  },

  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          { label: "All", value: "all" };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onEmployeeStepChange(previousStep, nextStep) {
      this.employeeFormTab = nextStep;
    },
    validateWizardStep(isValid, message) {
      if (!isValid) {
        this.$validator.validateAll();
        this.$vs.notify({
          title: "Required Information",
          text: message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
      return isValid;
    },
    validateEmployeeStep() {
      return this.validateWizardStep(
        this.employeeStepValid,
        "Complete all required employee fields using a valid email address."
      );
    },
    validateIdentificationStep() {
      return this.validateWizardStep(
        this.identificationStepValid,
        "Complete all required employee identification fields."
      );
    },
    validateSalaryStep() {
      return this.validateWizardStep(
        this.salaryStepValid,
        "Enter the annual working days and monthly salary rate."
      );
    },
    validateSalaryInformationStep() {
      return this.validateWizardStep(
        this.salaryInformationStepValid,
        "Complete the salary schedules and all required government identification numbers."
      );
    },
    calculateSalaryRates() {
      const salary = this.employeeSalary;
      if (salary.monthlyRate === null || !salary.annualWorkingDays || !salary.workHoursPerDay) return;
      const dailyRate = (Number(salary.monthlyRate) * 12) / Number(salary.annualWorkingDays);
      salary.dailyRate = Number(dailyRate.toFixed(2));
      salary.hourlyRate = Number((dailyRate / Number(salary.workHoursPerDay)).toFixed(2));
    },
    setIdentificationDefaults() {
      const lookup = this.$store.state.lookup;
      const defaults = {
        branch: lookup.getAllBranch,
        position: lookup.getAllPosition,
        department: lookup.getAllDepartment,
        division: lookup.getAllDivision,
        section: lookup.getAllSection,
        employeeCategory: lookup.getAllEmployeeCategory,
        civilStatus: lookup.getAllCivilStatus,
        nationality: lookup.getAllNationality,
        religion: lookup.getAllReligion,
        relationship: lookup.getAllRelationshipLookup,
      };

      Object.keys(defaults).forEach((field) => {
        if (!this.formSelections[field] && defaults[field].length) {
          this.$set(this.formSelections, field, defaults[field][0]);
        }
      });
    },
    setSalaryInformationDefaults() {
      const selections = this.formSelections;
      const activePaymentModeIds = this.activePaymentModes.map(
        (paymentMode) => paymentMode.paymentModeId
      );

      if (
        (!selections.paymentMode ||
          !activePaymentModeIds.includes(selections.paymentMode.paymentModeId)) &&
        this.activePaymentModes.length
      ) {
        this.$set(selections, "paymentMode", this.activePaymentModes[0]);
      }

      const taxReferenceIds = this.matchingTaxReferences.map(
        (taxReference) => taxReference.taxReferenceId
      );
      if (
        !selections.taxReference ||
        !taxReferenceIds.includes(selections.taxReference.taxReferenceId)
      ) {
        this.$set(
          selections,
          "taxReference",
          this.matchingTaxReferences.length ? this.matchingTaxReferences[0] : null
        );
      }

      if (!selections.salaryBasedOn) {
        const monthlyIncome = this.$store.state.lookup.getAllSalaryBasedOnLookup.find(
          (salaryBasedOn) =>
            String(salaryBasedOn.salaryBasedOnName || "").trim().toLowerCase() ===
            "monthly income"
        );
        if (monthlyIncome) this.$set(selections, "salaryBasedOn", monthlyIncome);
      }

      const periodIds = this.matchingPeriods.map((period) => period.periodId);
      ["sssPeriod", "philhealthPeriod", "pagibigPeriod", "whTaxPeriod"].forEach(
        (field) => {
          if (
            !selections[field] ||
            !periodIds.includes(selections[field].periodId)
          ) {
            this.$set(
              selections,
              field,
              this.matchingPeriods.length ? this.matchingPeriods[0] : null
            );
          }
        }
      );
    },
    promptAddNewEmployee() {
      this.resetEmployeeForm();
      this.activePromptNewEmployee = true;
    },
    resetEmployeeForm() {
      this.employeeFormTab = 0;
      this.registerNewEmployee = emptyEmployee();
      this.employeeIdentification = emptyIdentification();
      this.employeeSalary = emptySalary();
      this.employeeSalaryInformation = emptySalaryInformation();
      this.formSelections = emptySelections();
      this.setIdentificationDefaults();
      this.setSalaryInformationDefaults();
      this.$nextTick(() => {
        this.$validator.reset();
        if (this.$refs.employeeWizard) this.$refs.employeeWizard.reset();
      });
    },
    async findRegisteredUserId(registerResponse) {
      const responsePayload = registerResponse && registerResponse.data;
      const registered = responsePayload && responsePayload.data
        ? responsePayload.data
        : responsePayload || {};
      const directId = registered.id || registered.userId || registered.uid;
      if (directId) return directId;

      await this.$store.dispatch("hrms/getAllEmployee", {
        pageNumber: -1,
        pageSize: -1,
      });
      const employee = this.usersData.find(
        (item) => item.employeeCode === this.registerNewEmployee.employeeCode
      );
      if (!employee) throw new Error("The registered employee could not be found.");
      return employee.id;
    },
    async saveEmployeeDetails(userId) {
      const selections = this.formSelections;
      const currentUserId = this.$store.state.AppActiveUser.uid;
      const identificationResponse = await this.$store.dispatch(
        "hrms/getAllIdentification",
        userId
      );
      const salaryInformationResponse = await this.$store.dispatch(
        "hrms/getAllSalaryInformation",
        userId
      );
      const salaryResponse = await this.$store.dispatch("hrms/getAllSalary", userId);
      const existingIdentification = identificationResponse.data.data || {};
      const existingSalaryInformation = salaryInformationResponse.data.data || {};
      const existingSalaries = salaryResponse.data.data || [];
      const existingSalary = existingSalaries.find((salary) => salary.isUsed) || existingSalaries[0];

      const identification = {
        ...existingIdentification,
        ...this.employeeIdentification,
        userId,
        currentUserId,
        branchId: selections.branch.branchId,
        positionId: selections.position.positionId,
        departmentId: selections.department.departmentId,
        divisionId: selections.division.divisionId,
        sectionId: selections.section.sectionId,
        employeeCategoryId: selections.employeeCategory.employeeCategoryId,
        civilStatusId: selections.civilStatus.civilStatusId,
        nationalityId: selections.nationality.nationalityId,
        religionId: selections.religion.religionId,
        relationshipId: selections.relationship
          ? selections.relationship.relationshipId
          : existingIdentification.relationshipId,
        relativeEmployed: selections.relativeEmployed ? selections.relativeEmployed.id : null,
        immediateSupervisorId: selections.immediateSupervisor.id,
      };
      const salaryInformation = {
        ...existingSalaryInformation,
        ...this.employeeSalaryInformation,
        isSSS: true,
        isPhilhealth: true,
        isPagibig: true,
        isWHTax: true,
        userId,
        currentUserId,
        paymentModeId: selections.paymentMode.paymentModeId,
        taxReferenceId: selections.taxReference.taxReferenceId,
        salaryBasedOnId: selections.salaryBasedOn.salaryBasedOnId,
        sssPeriodId: selections.sssPeriod
          ? selections.sssPeriod.periodId
          : existingSalaryInformation.sssPeriodId,
        philhealthPeriodId: selections.philhealthPeriod
          ? selections.philhealthPeriod.periodId
          : existingSalaryInformation.philhealthPeriodId,
        pagibigPeriodId: selections.pagibigPeriod
          ? selections.pagibigPeriod.periodId
          : existingSalaryInformation.pagibigPeriodId,
        whTaxPeriodId: selections.whTaxPeriod
          ? selections.whTaxPeriod.periodId
          : existingSalaryInformation.whTaxPeriodId,
      };
      const salary = {
        ...(existingSalary || {}),
        ...this.employeeSalary,
        isUsed: true,
        isForOvertime: true,
        userId,
        currentUserId,
      };

      await Promise.all([
        this.$store.dispatch(
          existingIdentification.id ? "hrms/UpdateIdentification" : "hrms/AddIdentification",
          identification
        ),
        this.$store.dispatch(
          existingSalaryInformation.id ? "hrms/UpdateSalaryInformation" : "hrms/AddSalaryInformation",
          salaryInformation
        ),
        this.$store.dispatch(
          existingSalary ? "hrms/UpdateSalary" : "hrms/AddSalary",
          salary
        ),
      ]);
    },
    async onAddEmployee() {
      this.$vs.loading();

      this.registerNewEmployee.firstName = this.titleCase(
        this.registerNewEmployee.firstName
      );
      this.registerNewEmployee.lastName = this.titleCase(
        this.registerNewEmployee.lastName
      );
      this.registerNewEmployee.middleName = this.titleCase(
        this.registerNewEmployee.middleName
      );
      this.generateRandomPassword();

      try {
        const response = await this.$store.dispatch(
          "hrms/registerUser",
          this.registerNewEmployee
        );
        const userId = await this.findRegisteredUserId(response);
        await this.saveEmployeeDetails(userId);
        await this.$store.dispatch("hrms/getAllEmployee", {
          pageNumber: -1,
          pageSize: -1,
        });

        this.activePromptNewEmployee = false;
        this.resetEmployeeForm();
        Swal.fire({
          title: "Success",
          text: "Employee, identification, salary, and salary information were saved successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (err) {
        const message = err.response && err.response.data && err.response.data.message;
        if (message && message.code === 5) {
          Swal.fire({
            title: "Duplicate Employee Code",
            text: message.text,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Registration Failed",
            text: (message && message.text) || err.message || "Unable to save the employee.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } finally {
        this.$vs.loading.close();
      }
    },
    generateRandomPassword() {
      var lastName = this.registerNewEmployee.lastName
        .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, "")
        .replace(/\s/g, "")
        .toLowerCase();
      const year = new Date().getFullYear();
      this.registerNewEmployee.password =
        lastName + year + this.registerNewEmployee.employeeCode.toLowerCase();

      // Math.random().toString(36).substr(2, 8); //6 is the length of the string
      // var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      // var result = ""
      // var charactersLength = characters.length;

      // for ( var i = 0; i < 9 ; i++ ) {
      //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
      // }
      // this.registerNewEmployee.password = result

    },
    titleCase(str) {
      if (!str) return "";

      return str
        .trim()
        .split(" ")
        .filter((word) => word.length > 0)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
};
</script>

<style></style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.con-vs-dialog.employee-registration-prompt {
  .vs-dialog-text {
    position: relative;
    z-index: 2;
  }

  footer {
    z-index: 1;
  }

  .con-vs-tabs,
  .con-slot-tabs {
    overflow: visible;
  }

  .employee-salary-calendar {
    z-index: 1000;
  }

  .wizard-button-pending {
    background-color: #a8b3c9 !important;
    border-color: #a8b3c9 !important;
    color: #f8fafc !important;
  }
}
</style>
